import React from "react";
import { useSearchParams } from "react-router-dom";
import PatientRelease from "./PatientRelease";
import StaffRelease from "./StaffRelease";
import ClinicRelease from "./ClinicRelease";
import ReleaseTypeSwitch from "../components/ReleaseTypeSwitch";
import { ADD_RELEASE_TYPES, AddReleaseType, isAddReleaseType } from "../components/releaseTypes";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";

const HINTS: Record<AddReleaseType, string> = {
  patient: "Sell products to a patient, with prescribed medicines. Paid by card or cash.",
  employee: "Sell products to a staff member. Paid by card or cash.",
  clinic: "Products taken for clinic use by a staff member. Stock only, no payment.",
};

/** One release form at a time; the chosen kind lives in ?type= so it survives reloads and links. */
function AddRelease() {
  const [params, setParams] = useSearchParams();
  const raw = params.get("type");
  const type: AddReleaseType = isAddReleaseType(raw) ? raw : "patient";

  return (
    <div className="space-y-3 max-w-3xl mx-auto">
      {/* Header */}
      <div className="bg-white dark:bg-slate-800 rounded-[8px] shadow-lg shadow-slate-200/50 dark:shadow-slate-900/50 border border-slate-100 dark:border-slate-700 p-3">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2.5">
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 bg-emerald-100 dark:bg-emerald-900/40 rounded-md flex items-center justify-center">
              <LocalShippingIcon className="text-emerald-600 dark:text-emerald-300" sx={{ fontSize: 14 }} />
            </div>
            <div>
              <h2 className="text-xs font-bold text-slate-800 dark:text-slate-100">Add Product Release</h2>
              <p className="text-[10px] text-slate-500 dark:text-slate-400">{HINTS[type]}</p>
            </div>
          </div>
          <ReleaseTypeSwitch
            types={ADD_RELEASE_TYPES}
            value={type}
            onChange={(next) => setParams({ type: next }, { replace: true })}
          />
        </div>
      </div>

      {/* key: switching kind starts that form fresh */}
      {type === "patient" && <PatientRelease key="patient" />}
      {type === "employee" && <StaffRelease key="employee" />}
      {type === "clinic" && <ClinicRelease key="clinic" />}
    </div>
  );
}

export default AddRelease;
